import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { getDocumentsVersion, getDocTypes, publishDocument, disableDocument, reindexDocument } from "@/api/customerCenter/customerCenter";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
import modifyVersion from "./components/modifyVersion.vue";
import { version } from "sortablejs";
export default {
  name: "documentVersion",
  components: {
    modifyVersion: modifyVersion
  },
  mixins: [tabulation, gmToolNewPage, gmTool],
  directives: {
    'select-scroll': {
      bind: function bind(el, binding) {
        var SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');

        if (SELECTWRAP_DOM) {
          SELECTWRAP_DOM.addEventListener('scroll', function () {
            var condition = this.scrollHeight - this.scrollTop <= this.clientHeight + 1;

            if (condition) {
              binding.value();
            }
          });
        }
      }
    }
  },
  data: function data() {
    return {
      searchData: {
        page_size: 10,
        page: 1,
        game: '',
        game_id: '',
        paramsData: '',
        doc_id: '',
        version: '',
        doc_type: ''
      },
      searchTypeData: {
        page_size: 10,
        page: 1
      },
      tableData: [],
      total: 0,
      hasMore: false,
      documentTypeList: [],
      docTypeHasMore: false,
      // 下拉框是否还有下一页
      docTypeLoading: false
    };
  },
  created: function created() {
    this.getTypeList();

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    getTypeList: function getTypeList() {
      var _this = this;

      if (this.paramsData.server_id) {
        this.searchTypeData.server_id = this.paramsData.server_id;
      } else {
        this.searchTypeData.server_id = '';
      }

      getDocTypes(_objectSpread({}, this.searchTypeData)).then(function (res) {
        if (res.status === 'ok') {
          // 后端返回的真实字段为 doc_type 和 name
          var formattedItems = (res.items || []).map(function (item) {
            return {
              label: item.name + " (".concat(item.doc_type, ")"),
              // 拼接易读的标签
              value: item.doc_type
            };
          });
          _this.documentTypeList = formattedItems; // 判断是否还能继续加载下一页

          _this.docTypeHasMore = (res.items || []).length === _this.searchTypeData.page_size;
        }
      });
    },
    loadMoreDocTypes: function loadMoreDocTypes() {
      var _this2 = this;

      // 如果正在加载中，或者已经没有更多数据了，直接拦截
      if (this.docTypeLoading || !this.docTypeHasMore) return;
      this.docTypeLoading = true;
      this.searchTypeData.page += 1; // 页码加 1

      getDocTypes(_objectSpread({}, this.searchTypeData)).then(function (res) {
        if (res.status === 'ok') {
          var nextItems = (res.items || []).map(function (item) {
            return {
              label: item.name + " (".concat(item.doc_type, ")"),
              value: item.doc_type
            };
          }); // 将新一页的数据【追加】到旧数组后面

          _this2.documentTypeList = _this2.documentTypeList.concat(nextItems); // 更新是否还有下一页的状态

          _this2.docTypeHasMore = (res.items || []).length === _this2.searchTypeData.page_size;
        }
      }).finally(function () {
        _this2.docTypeLoading = false;
      });
    },
    getServer: function getServer() {
      var _this3 = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this3.serverList = res.data;
        }
      });
    },
    sizeChange: function sizeChange(val) {
      this.searchData.page_size = val;
      this.searchClick(1);
    },
    changePage: function changePage(targetPage) {
      this.searchClick(targetPage);
    },
    searchClick: function searchClick(e) {
      var _this4 = this;

      this.searchData.page = e;
      this.tableData = [];

      if (this.paramsData.server_id) {
        this.searchData.server_id = this.paramsData.server_id;
      } else {
        this.searchData.server_id = '';
        this.$message.error('请选择服务器');
        return;
      }

      if (this.searchData.doc_type && !this.searchData.doc_id) {
        this.$message.error('请填写doc_id');
        return;
      }

      this.searchData.game = this.rawData.game_mark;
      this.searchData.game_id = this.rawData.game_id;
      this.reqLoading = true;
      getDocumentsVersion(_objectSpread({}, this.searchData)).then(function (res) {
        if (res.status == 'ok') {
          var list = _this4.rawData.game_mark.indexOf('royalpirates') > -1 ? _this4.serverList : _this4.serverListYJ;
          res.items.forEach(function (item) {
            var foundData = list.find(function (b) {
              return b.serverID == item.server_id;
            });
            item.server_name = foundData ? foundData.serverName : '/';
          });
          _this4.tableData = res.items || [];
          _this4.hasMore = _this4.tableData.length === _this4.searchData.page_size;
        }
      }).finally(function () {
        _this4.reqLoading = false;
      });
    },
    publishData: function publishData(data) {
      var _this5 = this;

      this.$confirm("此操作将发布该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                publishDocument({
                  doc_type: data.doc_type,
                  doc_id: data.doc_id,
                  version: data.version,
                  game: data.game,
                  server_id: data.server_id,
                  env: data.env
                }).then(function (res) {
                  if (res.status == 'succeeded') {
                    _this5.$message({
                      type: "success",
                      message: '发布成功'
                    });
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },
    forbidden: function forbidden(data) {
      var _this6 = this;

      this.$confirm("此操作将禁用该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                disableDocument({
                  doc_type: data.doc_type,
                  doc_id: data.doc_id,
                  version: data.version,
                  game: data.game,
                  server_id: data.server_id,
                  env: data.env
                }).then(function (res) {
                  if (res.status == 'succeeded') {
                    _this6.$message({
                      type: "success",
                      message: '禁用成功'
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    },
    reindexData: function reindexData(data) {
      var _this7 = this;

      this.$confirm("此操作将重新索引该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                reindexDocument({
                  doc_type: data.doc_type,
                  doc_id: data.doc_id,
                  version: data.version,
                  game: data.game,
                  server_id: data.server_id,
                  env: data.env
                }).then(function (res) {
                  if (res.status == 'succeeded') {
                    _this7.$message({
                      type: "success",
                      message: '重新索引成功'
                    });
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    }
  }
};